import { render, staticRenderFns } from "./ShikishaBetBetslip.vue?vue&type=template&id=16517390"
import script from "./ShikishaBetBetslip.vue?vue&type=script&lang=js"
export * from "./ShikishaBetBetslip.vue?vue&type=script&lang=js"
import style0 from "./ShikishaBetBetslip.vue?vue&type=style&index=0&id=16517390&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports